import React, { createContext, useCallback, useContext, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Typography from "@mui/material/Typography";

const BackdropContext = createContext(null);

export function useBackdrop() {
  return useContext(BackdropContext);
}

export const BackdropProvider = ({ children }) => {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [backdropMessage, setBackdropMessage] = useState("");

  const openBackdrop = useCallback(message => {
    setBackdropMessage(message);
    setBackdropOpen(true);
  }, []);

  const closeBackdrop = useCallback(() => {
    setBackdropOpen(false);
    setBackdropMessage("");
  }, []);

  return (
    <BackdropContext.Provider value={{ openBackdrop, closeBackdrop }}>
      {children}
      <Backdrop
        sx={{ color: "#fff", zIndex: theme => theme.zIndex.drawer + 1 }}
        open={backdropOpen}
      >
        <Typography variant="h5" sx={{ mt: 2, mb: 2 }}>
          {backdropMessage}
        </Typography>
      </Backdrop>
    </BackdropContext.Provider>
  );
};
